import React from 'react'
import Success from '../features/success/Success'

const SuccessPage = () => {
  document.title = "Success - Plant Seller";
  return (
    <Success />
  )
}

export default SuccessPage